import React from "react";
import { Toast as UI5Toast } from "@ui5/webcomponents-react";

export const Toast = React.forwardRef(
  (
    {
      children,
      duration = 3000,
      placement = "BottomCenter",
      open,
      onAfterClose,
      ...props
    },
    ref
  ) => {
    return (
      <UI5Toast
        ref={ref}
        duration={duration}
        placement={placement}
        open={open}
        onAfterClose={onAfterClose}
        {...props}
      >
        {children}
      </UI5Toast>
    );
  }
);

Toast.displayName = "Toast";
